import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { IoLogoLinkedin } from "react-icons/io5";
import log from "../../../images/NEW FATS LOGO.png";
import googleplay from "../../../images/google-play-store-logo.png.webp"
import applestore from "../../../images/apple-store-logo.png";
import { useQuery } from "react-query";
import newRequest from "../../../utils/newRequest";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Footer.css"
const Footer = () => {



  const { t, i18n } = useTranslation();
  const { isLoading, data, error } = useQuery("fetchfooter", async () => {
    try {
      const response = await newRequest.get("/footer_frontSide");
      console.log('Menu', response.data);
      return response?.data.filter(item => item.status === 1) || [];
      // return response?.data || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  });
  return (
    <div>
      <div className="pt-4 gap-2 sm:px-16 px-8  h-auto w-full bg-[#2b4892] relative">
        <div className="w-full grid 2xl:grid-cols-6 lg:grid-cols-6 grid-cols-3 pt-8">
          <div
            className={`h-auto w-full flex flex-col gap-8 relative order-first`}
          >
            <div className="logo">
              <img src={log} alt="" className="h-24 w-auto cursor-pointer" />
            </div>
            <div className={`text-gray-300 flex flex-col gap-1`}>
              <p
                // href="https://gs1.org.sa/select-business-type"
                // target="_blank"
                // rel="noopener noreferrer"
                className="transition-colors text-[#aab5d3] duration-300 hover:text-[#fff]"
              >
                {t("Fixed Asset Tracking System")}
              </p>
              <div className="flex space-x-4 mt-6">
                <FaFacebookSquare className="cursor-pointer text-gray-300 hover:text-white transition-colors duration-300" />
                <IoLogoYoutube className="cursor-pointer text-gray-300 hover:text-white transition-colors duration-300" />
                <IoLogoLinkedin className="cursor-pointer text-gray-300 hover:text-white transition-colors duration-300" />
              </div>
            </div>
          </div>

          <div className={`h-auto w-full flex flex-col gap-8 relative `}>
            <h2 className="text-white text-xl font-semibold relative">
              {t("Get the App")}
            </h2>
            <div className={`text-gray-300 flex flex-col gap-1 w-1/2`}>
              <img src={applestore} className="h-14 w-100 cursor-pointer"></img>
              <a href="https://play.google.com/store/apps/details?id=com.nartec.fats_system" target="_blanck">
                <img
                  src={googleplay}
                  className="h-14 w-auto cursor-pointer mt-5"
                ></img>
              </a>
            </div>
          </div>

          {data?.map((section, index) => (
            <div
              className={`h-auto w-full flex flex-col gap-8 relative order-last my-4`}
            >
              <h2
                className="text-white text-xl font-semibold relative custom-footer-heading"
                style={{ color: "white", color: "white !important" }}
                dangerouslySetInnerHTML={{
                  __html:
                    i18n.language === "ar"
                      ? section?.name_ar
                      : section?.name_en,
                }}
              ></h2>

              <div className={`text-gray-300 flex flex-col gap-1`}>
                {section.mega_menu_categories.map((category, catIndex) => (
                  <Link
                    key={catIndex}
                    to={`/${category.url}`}
                    // target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors text-[#aab5d3] duration-300 hover:text-[#fff] cursor-pointer"
                  >
                    {i18n.language === "ar"
                      ? category?.category_name_ar
                      : category?.category_name_en}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        {/* <div
          className="h-[400px] w-full bg-cover bg-center bg-no-repeat -mt-40"
          style={{
            backgroundImage: `url('https://www.assetpanda.com/wp-content/themes/e25-base-theme/dist/images/footer-bg.svg')`,
          }}
        ></div> */}
      </div>
    </div>
  );
};

export default Footer;
